import { combineReducers } from 'redux';
import { RouterState, connectRouter } from 'connected-react-router';
import { History } from 'history';
import loadingReducer, { LoadingState } from './loading'
import userReducer, { UserState, userOperations } from './user';
import systemStateMessageReducer,
  { SystemStateMessageState, systemStateMessageOperations } from './systemStateMessage';
import siteInfoListReducer,
  { SiteInfoListState, siteInfoListOperations } from './siteInfoList';
import siteInfoListSubdivReducer,
  { SiteInfoListSubdivState, siteInfoListSubdivOperations } from './siteInfoListSubdiv';
import siteInfoListObsrecReducer,
  { SiteInfoListObsrecState, siteInfoListObsrecOperations } from './siteInfoListObsrec';
import inferenceResultReducer,
  { InferenceResultState, inferenceResultOperations } from './inference';
import inferenceResultSubdivReducer,
  { InferenceResultSubdivState, inferenceResultSubdivOperations } from './inferenceSubdiv';
import inferenceResultObsrecReducer,
  { InferenceResultObsrecState, inferenceResultObsrecOperations } from './inferenceObsrec';
import kansatsuKirokuReducer,
  { KansatsuKirokuState, kansatsuKirokuOperations } from './kansatsuKiroku';
import kansatsuKirokuSubdivReducer,
  { KansatsuKirokuSubdivState, kansatsuKirokuSubdivOperations } from './kansatsuKirokuSubdiv';
import kansatsuKirokuObsrecReducer,
  { KansatsuKirokuObsrecState, kansatsuKirokuObsrecOperations } from './kansatsuKirokuObsrec';
import endpointStatusReducer,
  { EndpointStatusState, endpointStatusOperations } from './endpointStatus';
import endpointStatusSubdivReducer,
  { EndpointStatusSubdivState, endpointStatusSubdivOperations } from './endpointStatusSubdiv';
import endpointOperationReducer,
  { EndpointOperationState, endpointOperationOperations } from './endpointOperation';
import endpointOperationSubdivReducer,
  { EndpointOperationSubdivState, endpointOperationSubdivOperations } from './endpointOperationSubdiv';
import fullArchiveDownloadReducer,
  { FullArchiveDownloadState, fullArchiveDownloadOperations } from './fullArchiveDownload';
import fullArchiveDownloadSubdivReducer,
  { FullArchiveDownloadSubdivState, fullArchiveDownloadSubdivOperations } from './fullArchiveDownloadSubdiv';
import fullArchiveDownloadObsrecReducer,
  { FullArchiveDownloadObsrecState, fullArchiveDownloadObsrecOperations } from './fullArchiveDownloadObsrec';

export interface IAppState {
  router: RouterState;   // Router用の領域
  loading: LoadingState;
  user: UserState;
  systemStateMessage: SystemStateMessageState;
  siteInfoList: SiteInfoListState;
  siteInfoListSubdiv: SiteInfoListSubdivState;
  inferenceResult: InferenceResultState;
  inferenceResultSubdiv: InferenceResultSubdivState;
  inferenceResultObsrec: InferenceResultObsrecState;
  kansatsuKiroku: KansatsuKirokuState;
  kansatsuKirokuSubdiv: KansatsuKirokuSubdivState;
  kansatsuKirokuObsrec: KansatsuKirokuObsrecState;
  endpointStatus: EndpointStatusState;
  endpointStatusSubdiv: EndpointStatusSubdivState;
  endpointOperation: EndpointOperationState;
  endpointOperationSubdiv: EndpointOperationSubdivState;
  fullArchiveDownload: FullArchiveDownloadState;
  fullArchiveDownloadSubdiv: FullArchiveDownloadSubdivState;
  fullArchiveDownloadObsrec: FullArchiveDownloadObsrecState;
  siteInfoListObsrec: SiteInfoListObsrecState;
}

export {
  userOperations,
  systemStateMessageOperations,
  siteInfoListOperations,
  siteInfoListSubdivOperations,
  inferenceResultOperations,
  inferenceResultSubdivOperations,
  inferenceResultObsrecOperations,
  kansatsuKirokuOperations,
  kansatsuKirokuSubdivOperations,
  endpointStatusOperations,
  endpointStatusSubdivOperations,
  endpointOperationOperations,
  endpointOperationSubdivOperations,
  fullArchiveDownloadOperations,
  fullArchiveDownloadSubdivOperations,
  fullArchiveDownloadObsrecOperations,
  siteInfoListObsrecOperations,
  kansatsuKirokuObsrecOperations,
};

export default (history: History<any>) => combineReducers({
  router: connectRouter(history),
  loading: loadingReducer,
  user: userReducer,
  systemStateMessage: systemStateMessageReducer,
  siteInfoList: siteInfoListReducer,
  siteInfoListSubdiv: siteInfoListSubdivReducer,
  siteInfoListObsrec: siteInfoListObsrecReducer,
  inferenceResult: inferenceResultReducer,
  inferenceResultSubdiv: inferenceResultSubdivReducer,
  inferenceResultObsrec: inferenceResultObsrecReducer,
  kansatsuKiroku: kansatsuKirokuReducer,
  kansatsuKirokuSubdiv: kansatsuKirokuSubdivReducer,
  kansatsuKirokuObsrec: kansatsuKirokuObsrecReducer,
  endpointStatus: endpointStatusReducer,
  endpointStatusSubdiv: endpointStatusSubdivReducer,
  endpointOperation: endpointOperationReducer,
  endpointOperationSubdiv: endpointOperationSubdivReducer,
  fullArchiveDownload: fullArchiveDownloadReducer,
  fullArchiveDownloadSubdiv: fullArchiveDownloadSubdivReducer,
  fullArchiveDownloadObsrec: fullArchiveDownloadObsrecReducer,
});



// WEBPACK FOOTER //
// ./src/redux/modules/index.ts